// Authentic stadium / supporter header images per club, plus shared match action.
const B = "https://customer-assets-v7afamib.emergentagent.net/job_dynamos-portal/artifacts/";

export const CLUB_HEADER = {
  hardrock: B + "xi8bycfr_772894250_1621559709309344_633544013887437080_n.png.jpeg",
  highlanders: B + "8x1ro636_689490092_1411513441009661_5214206865389091865_n.webp",
  "caps-united": B + "khyo2jyu_656822181_1369328008561538_4679333837254661698_n.webp",
  "bulawayo-chiefs": B + "g8g95lu8_673798600_1391881492972856_5687275933700011594_n.jpg",
  kariba: B + "1vcq9wve_680435760_1400294448798227_2864567781872771652_n.jpg",
  scottland: B + "zpzu3vnq_749652450_1658726422925153_3934966473358751488_n.jpg",
  herentals: B + "a0u6jlu4_689254691_1404517848375887_1904107858492139941_n.webp",
  hunters: B + "a0u6jlu4_689254691_1404517848375887_1904107858492139941_n.webp",
  telone: B + "h6qo72ql_721463776_1438389004988771_7202982144070882248_n.webp",
};

export const DEFAULT_HEADER = B + "9ljrk7in_772119602_1374196178247998_4845697400721189189_n.png.jpeg";
export const MATCH_ACTION = B + "cgriyhns_708517230_1424590573035281_51104715406452687_n.webp";
export const STADIUM_AERIAL = B + "9ljrk7in_772119602_1374196178247998_4845697400721189189_n.png.jpeg";
